import { useQuery } from "@tanstack/react-query";
import { api } from "../../helpers/api";
import { Link } from "react-router-dom";
import { useState } from "react";
import UserCard, { UserCardSkeleton } from "./SubscriptionCardSkeletion";
import { DBUserType, Tabs, UserTabs } from "../users/UserTabs";

export default function RecentSubscriptions({ onDelete, onView, onBlock }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState<any>(Tabs.Users);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["most-active-users", selectedType],
    queryFn: () =>
      api.getUsers({
        page: 0,
        limit: 10,
        type: DBUserType[selectedType],
        sortBy: "lastActive",
      }),
  });

  return (
    <div className="flex-1 rounded-[16px] bg-white shadow-[0px_8px_20px_0px_rgba(0,0,0,0.03)] h-[75dvh] flex flex-col !p-0 !gap-0">
      {/* <EntityDetails
        isOpen={isOpen}
        handleClose={() => {
          setIsOpen(false);
        }}
        data={selectedEntity}
        refetchEntityDetails={refetch}
      /> */}

      <div className="flex flex-row justify-between items-center border-b border-b-[#D7D7D7] p-6">
        <span className="text-xl leading-[113.6%] font-bold">
          Most active users
        </span>
        <Link
          to="/users"
          className="text-primary hover:opacity-50 font-medium leading-[113.6%] text-base h-fit"
        >
          View all
        </Link>
      </div>
      <div className="my-3.5 mx-4 [&_button]:flex-1">
        <UserTabs selectedTab={selectedType} setSelectedTab={setSelectedType} />
      </div>
      {!isLoading && (
        <div className="flex flex-col overflow-auto px-4 gap-3.5">
          {data?.map((user: any) => (
            <UserCard
              key={user.id}
              user={user}
              onView={() => onView({ user, tab: selectedType })}
              onBlock={() => onBlock(user)}
              onDelete={() => onDelete(user)}
            />
          ))}
        </div>
      )}
      {isLoading && (
        <div className="flex flex-col overflow-auto">
          <UserCardSkeleton />
          <UserCardSkeleton />
          <UserCardSkeleton />
        </div>
      )}
    </div>
  );
}
